import { TextField, styled } from '@mui/material';
import { colors } from '../../../theme';

export const DarkTextField = styled(TextField)({
  flex: 1,
  '& .MuiOutlinedInput-root': {
    backgroundColor: colors.whiteAlpha[10],
    borderRadius: '8px',
    color: colors.pureWhite,
    '& fieldset': {
      borderColor: colors.whiteAlpha[20],
    },
    '&:hover fieldset': {
      borderColor: colors.whiteAlpha[30],
    },
    '&.Mui-focused fieldset': {
      borderColor: colors.signalOrange,
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '16px 20px',
    '&::placeholder': {
      color: colors.whiteAlpha[50],
      opacity: 1,
    },
  },
});
